import React from 'react';

import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonPage,
} from '@ionic/react';
import {
  cubeOutline,
  logInOutline,
  personCircleSharp,
  refreshCircleOutline,
} from 'ionicons/icons';

import { useOktaAuth } from '@okta/okta-react';
import { useHistory } from 'react-router-dom';

import { useStorage } from 'components/Storage';
import TopToolbar from 'components/TopToolbar';
import Typography from 'components/Typography';

const SettingsPage: React.FC = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const storage = useStorage();
  const history = useHistory();

  const handleResetCache = async () => {
    await Promise.race([
      navigator.serviceWorker.ready.then(registration => {
        return registration.unregister();
      }),
      await new Promise(resolve => setTimeout(() => resolve('timeout'), 1000)),
    ]);

    await storage?.clear();
    //onupgradeneeded
    window.location.reload();
  };
  const name = authState?.idToken?.claims?.name;
  const email = authState?.idToken?.claims?.email;
  const env = `${process.env.REACT_APP_ENV_NAME}@${process.env.REACT_APP_APP_VERSION}`;

  const handleLogout = async () => {
    oktaAuth.tokenManager.clear();
    history.push('/login');
  };

  return (
    <IonPage>
      <IonHeader>
        <TopToolbar title={'Settings'} />
      </IonHeader>
      <IonContent>
        <IonItem>
          <IonIcon
            icon={personCircleSharp}
            slot={'start'}
            color={'medium-shade'}
          />
          <IonLabel>
            <Typography variant={'subtitle1'}>{name}</Typography>
            <p>{email}</p>
          </IonLabel>
        </IonItem>
        <IonItem>
          <IonIcon icon={cubeOutline} slot={'start'} color={'medium-shade'} />
          <Typography variant={'subtitle1'}>{env}</Typography>
        </IonItem>
        <IonItem button={true} detail={false} onClick={handleResetCache}>
          <IonIcon
            icon={refreshCircleOutline}
            slot={'start'}
            color={'medium-shade'}
          />
          <Typography variant={'subtitle1'}>Reset cache</Typography>
        </IonItem>
        <IonItem button={true} detail={false} onClick={handleLogout}>
          <IonIcon icon={logInOutline} slot={'start'} color={'medium-shade'} />
          <Typography variant={'subtitle1'}>Logout</Typography>
        </IonItem>
      </IonContent>
    </IonPage>
  );
};

export default React.memo(SettingsPage);
